import { useEffect, useState } from "react";
import { auth } from "@/integrations/firebase/client";
import { getIdTokenResult, onIdTokenChanged, User } from "firebase/auth";

const ADMIN_EMAIL = "samuel.calfati@gmail.com";

export function useAdmin(): { ready: boolean; isAdmin: boolean; user: User | null } {
  const [ready, setReady] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [user, setUser] = useState<User | null>(auth.currentUser);

  useEffect(() => {
    const unsub = onIdTokenChanged(auth, async (u) => {
      setUser(u);
      if (!u) {
        setIsAdmin(false);
        setReady(true);
        return;
      }
      try {
        const token = await getIdTokenResult(u, true);
        const claimAdmin = token.claims && (token.claims as any).admin === true;
        const emailAdmin = (u.email || "").toLowerCase() === ADMIN_EMAIL;
        setIsAdmin(!!claimAdmin || emailAdmin);
      } catch {
        const emailAdmin = (u.email || "").toLowerCase() === ADMIN_EMAIL;
        setIsAdmin(emailAdmin);
      } finally {
        setReady(true);
      }
    });
    return () => unsub();
  }, []);

  return { ready, isAdmin, user };
}


